import { useCallback, useState } from 'react'

export function useInput(initialValue: React.ReactText = '') {
  const [value, setValue] = useState(initialValue)
  const [touched, setTouched] = useState(false)
  const [isFocused, setFocused] = useState(false)

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }, [])
  const onClear = useCallback(() => {
    setValue('')
  }, [])
  const onFocus = useCallback(() => {
    setTouched(true)
    setFocused(true)
  }, [])
  const onBlur = useCallback(() => {
    setFocused(false)
  }, [])
  const onFinish = useCallback(() => {
    setFocused(false)
    setTouched(false)
    setValue('')
  }, [])

  return {
    value,
    setValue,
    onChange,
    onClear,
    touched,
    onFocus,
    onBlur,
    onFinish,
    isFocused,
  }
}
